import memberPackApi from "../api/memberPack";

const actions = {
  async fetchMemberPack({ commit }, params) {
    const { packId, serviceArea } = params;
    const response = await memberPackApi.get(packId, serviceArea);
    // API contract: payload is under response.data.result
    commit("setMemberPack", response.data.result);
    return response.data.result;
  },

  async updateMemberPack({ commit }, params) {
    const { packId, serviceArea, memberPackLead } = params;
    const payload = { memberPackLead };
    const response = await memberPackApi.upsert(packId, serviceArea, payload);
    // API contract: upsert returns data.row with the saved record and may include created flag
    commit("setMemberPack", response.data.row);
    return response.data;
  },
};

const mutations = {
  setMemberPack(state, payload) {
    state.memberPack = payload || {};
  },
};

const state = {
  memberPack: {},
};

export default {
  actions,
  mutations,
  namespaced: true,
  state,
};
